// @ts-nocheck
/* eslint-disable */
import Scene from "~/scene";

// namespace IP - inter-polation
Mapy.Util.IP = {};

/**
 * Spocitani vzdalenosti mezid body coords.
 * @param {Array[SceneCoords]} coords Pole souradnic
 * @param {Object} [opts] Volitelna konfigurace
 * @param {Boolean} [opts.insertZero=true] Vlozit 0 na zacatek pole?
 * @param {Boolean} [opts.stepDistance=false] U kazdeho zaznamu pouze delku mezi 2 body? Ne celkovou?
 * @return {Array[Number]}
 */
Mapy.Util.IP.countDistances = (coords, opts) => {
	let options = Object.assign({
		insertZero: true,
		stepDistance: false
	}, opts);
	let distances = [];

	if (options.insertZero) {
		distances.push(0);
	}

	coords.forEach((coord, ind) => {
		if (!ind) return;

		let prevDistance = options.stepDistance ? 0 : distances[ind - 1];
		distances.push(prevDistance + coord.distance(coords[ind - 1]));
	});

	return distances;
};

/**
 * Chceme ziskat bod na geometrii n bodu, podle vzdalenosti od zacatku.
 * Pole bodu a jejich vzdalenosti musi mit stejnou delku.
 *
 * @param {Number} distance Vzdalenost od startu v [m]
 * @param {Array[SceneCoords]} coords Pole bodu geometrie
 * @param {Array[Number]} distances Pole vzdalenosti pro jednotlive body
 * @return {Array[SceneCoords]} Novy bod na dane geometrii ve WGS84
 */
Mapy.Util.IP.getCoordAtDistance = (distance, coords, distances) => {
	if (distances.length != coords.length) return Scene.coordsFromWGS84(0, 0);

	let max = coords.length; // distances a coords length musi byt stejne!
	let maxDistance = distances[max - 1];
	let coord = null;

	distance = Math.max(Math.min(distance, maxDistance), 0);

	for (let i = 0; i < max - 1; i++) {
		let leftDist = distances[i];
		let rightDist = distances[i + 1]

		if (distance >= leftDist && distance <= rightDist) {
			let dist = rightDist - leftDist;

			if (dist > 0) {
				let ratioLeft = 1 - ((distance - leftDist) / dist);
				let ratioRight = 1 - ((rightDist - distance) / dist);
				let leftCoords = coords[i].toWGS84();
				let rightCoords = coords[i + 1].toWGS84();
				let x = ratioLeft * leftCoords[0] + ratioRight * rightCoords[0];
				let y = ratioLeft * leftCoords[1] + ratioRight * rightCoords[1];
				coord = Scene.coordsFromWGS84(x, y);
			}
			else {
				coord = coords[i];
			}
			break;
		}
	}

	return coord;
};

/**
 * Zvetseni cesty - geometrie n bodu na novou velikost count.
 * Zachovova vstupni body. Pokud je trasa vetsi nez zadany pocet bodu, tak se vstupni body nezachovavaji.
 *
 * @param {Array[SceneCoords]} coords Pole bodu geometrie
 * @param {Object} [opts] Volitelna konfigurace
 * @param {Number} [opts.count=100] Novy pocet bodu, default 100
 * @param {Number} [opts.mapToCoords] Ve vystupu je dalsi parametr, ktery oznacuje indexy na puvodni pole
 * @return {Array[SceneCoords]} Vystupni pole s count prvky
 */
Mapy.Util.IP.resizePath = (coords, opts) => {
	let options = Object.assign({
		count: 100,
		mapToCoords: false,
		returnWGS84: false
	}, opts);
	let count = options.count;
	let len = coords.length;
	let incPath = count > len;
	// pro vypocet potrebujeme vzdalenosti do puvodniho pole bodu
	let distances = Mapy.Util.IP.countDistances(coords);

	// zvetseni trasy
	if (incPath) {
		// vysledny pocet - start a cil je zachovan, pokud je vic jak 2 body, zbytek odecteme
		count -= len > 2 ? len - 2 : 0;
		count = Math.max(count, 0);
	}
	else {
		options.mapToCoords = false;
	}

	// na jake dilky rozdelit trasu?
	let distanceInc = distances[len - 1] / (count - 1);
	let curDistance = 0;
	let allDistances = [];

	// naplnime pole vzdalenosti
	for (let i = 0; i < count; i++) {
		allDistances.push(curDistance);
		curDistance += distanceInc;
	}

	if (incPath) {
		// vlozime dilci body ze vstupniho pole, start/cil je vynechan
		coords.forEach((i, ind) => {
			if (ind > 0 && ind != (len - 1)) {
				allDistances.push(distances[ind]);
			}
		});

		// seradime - aby posledne vlozene nebyly na konci
		allDistances.sort((a,b) => {
			return (a-b);
		});
	}

	let output = [];
	let mapToCoords = [];
	// len tady pouzijeme jako konec all distances pole
	len = allDistances.length - 1;

	// pro pole vzdalenosti spocitame jejich x a y
	allDistances.forEach((dist, ind) => {
		let coord = Mapy.Util.IP.getCoordAtDistance(dist, coords, distances);

		if (options.mapToCoords && (ind === 0 || ind === len || distances.indexOf(dist) != -1)) {
			mapToCoords.push(ind);
		}

		output.push(options.returnWGS84 ? coord.toWGS84() : coord);
	});

	if (options.mapToCoords) {
		return {
			output,
			mapToCoords
		};
	}
	else return output;
};

/**
 * Vrat souradnici a vzdalenost od zacatku na indexu <0; delka pole - 1> float
 *
 * @param {Float} index Index v poli
 * @param {Array[SceneCoords]} coords Pole bodu geometrie
 * @param {Array[Number]} [distances] Pole vzdalenosti pro jednotlive body - volitelne
 * @return {Object} nove souradnice a vzdalenost od zacatku
 */
Mapy.Util.IP.dataAtIndex = (index, coords, distances) => {
	let li = Math.floor(index);
	let ri = Math.min(li + 1, coords.length - 1);
	let ratioLeft = li != ri ? 1 - (index - li) : 1;
	let ratioRight = li != ri ? 1 - (ri - index) : 0;
	let leftCoords = coords[li];
	let rightCoords = coords[ri];
	let x = ratioLeft * leftCoords.x + ratioRight * rightCoords.x;
	let y = ratioLeft * leftCoords.y + ratioRight * rightCoords.y;
	let outputCoords = Scene.coordsFromWGS84(x, y);
	let distance = distances && distances.length == coords.length ? distances[li] + coords[li].distance(outputCoords) : 0;

	return {
		coords: outputCoords,
		distance
	};
};
